<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            .form__field
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_showTime') }}
                .form__field-body
                    cs-multiselect(
                        :options="seconds"
                        v-model="params.showTime"
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_select')"
                        :custom-label="secondsLabel"
                        :multiple="false"
                        :allow-empty="false"
                        :hideSelected="true"
                        :searchable="false"
                    )
            .form__field
                label.form__label
                    | {{ $i18n.t('progress.progress_preview_timeLimit') }}
                .form__field-body
                    cs-multiselect(
                        v-model="params.timeLimit"
                        :options="minutes"
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_select')"
                        :custom-label="timeLimitLabel"
                        :multiple="false"
                        :hideSelected="true"
                        :searchable="false"
                    )
            .form__field
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_movement', {element: $i18n.tc('trainer.trainer_textForm_words', 0)}) }}
                .form__field-body
                    cs-checkbox(v-model='params.wordsMovement')
            .form__field
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_music') }}
                .form__field-body-checkbox
                    cs-checkbox(
                        v-model="params.isMusicOn"
                        :checked="params && params.isMusicOn"
                    )
            .form__field
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_distractingPictures') }}
                .form__field-body-checkbox
                    cs-checkbox(
                        v-model='params.pictures',
                        :checked="params && params.pictures",
                    )
            divider
            slot(name='parameters')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if="gameMode === 'free-game'")
                    cs-button.form__button(color="blue", @click='saveGameMode' :disabled="isSaveButtonDisabled")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(color="blue", @click='saveGame' :disabled="isSaveButtonDisabled")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else='')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='saveGame' :disabled="isSaveButtonDisabled")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from '../../../utils/trainer/getInitParameters';
    import { mapState } from 'vuex';
    import { cloneDeep } from 'lodash';
    import multiplayerFormMixin from '../../../utils/multiplayer/formMixin';
    import IntervalConfig from '../../trainer/configs/IntervalConfig';

    export default {
        props: {
            slug: String,
            courseType: String,
            id: [Number, String],
            usersIds: [Array, String],
            homeworkId: [Number, String],
            gameMode: String,
            gameId: [Number, String],
            generatorGameIndex: Number,
            generatorSettings: Boolean,
            levelAnswerDuration: Number,
        },
        mixins: [GameFormMixin, multiplayerFormMixin],
        mounted() {
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(this, 'params',
                        getInitParameters({
                            slug: this.slug,
                            parameters: {
                                default: cloneDeep(this.gamesParameters[this.slug]),
                            },
                        })
                    );
                } else {
                    this.params = cloneDeep(TrainerGames.games).find(
                        ({ slug }) => slug === this.slug
                    ).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
        },
        data() {
            return {
                selectedGameMode: null,
                viewType: null,
                isMusicOn: false,
                params: null,
                minutes: IntervalConfig.timeLimitForHandsUp,
                seconds: IntervalConfig.secondForMentalDrawing,
            };
        },
        methods: {
            secondsLabel(second) {
                return second + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
            },
            timeLimitLabel(amount) {
                return amount === 0
                    ? this.$i18n.t('trainer.trainer_gameFormSettingValue_off')
                    : amount + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_minutes');
            },
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
            }),
            isSaveButtonDisabled() {
                return false;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: 0.5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px;
        @include media($sm) {
            align-self: center;
            width: 250px;
        }
        @include media($md) {
            margin: 0 10px;
        }
    }
</style>
